import React from 'react'

import { GrUserExpert } from "react-icons/gr";
import { FaCheckCircle } from 'react-icons/fa';
import { FaClockRotateLeft } from 'react-icons/fa6';
const Gallery = () => {
  return (
    <div class='gallery-div'>
        <div class='elect-div1'>
            {/* <h1 class='hvac-h'>Gallery</h1> */}
        </div>
        <h1 class='gall-g'>Gallery</h1>
        {/* <div class='container'>
            <div class='row mt-5'>
              <div class='col-12 col-sm-12 col-md-6 col-lg-4'>
                <div class='d-flex justify-content-center'>
                <Link to={'/warehouse'}>
                <img src='./Images/ware.png' alt='' height={300} width={300} class='gallery-img'/>
                </Link>
                </div>
                <h5 class='gallery-head d-flex justify-content-center '>Warehouse Fire Pumps</h5>
              </div>
              <div class='col-12 col-sm-12 col-md-6 col-lg-4'>
                <div class='d-flex justify-content-center'>
                <Link to={'/firehydrant'}>
                <img src='./Images/factory.png' alt='' height={300} width={300} class='gallery-img'/>
                </Link>
                </div>
                <h5 class='gallery-head d-flex justify-content-center '>Factory Hydrant Installation</h5>
              </div>
              <div class='col-12 col-sm-12 col-md-6 col-lg-4'>
                <div class='d-flex justify-content-center'>
                <Link to={'/sprinkler'}>
                <img src='./Images/office.png' alt='' height={300} width={300} class='gallery-img'/>
                </Link>
                </div>
                <h5 class='gallery-head d-flex justify-content-center '>Office Sprinkler System</h5>
              </div>
            </div>
            <div class='row mt-5'>
              <div class='col-12 col-sm-12 col-md-6 col-lg-4'>
                <div class='d-flex justify-content-center'>
                <Link >
                <img src='./Images/control.png' alt='' height={300} width={300} class='gallery-img'/>
                </Link>
                </div>
                <h5 class='gallery-head d-flex justify-content-center '>Control panel Setup</h5>
              </div>
              <div class='col-12 col-sm-12 col-md-6 col-lg-4'>
                <div class='d-flex justify-content-center'>
                <Link>
                <img src='./Images/industry.png' alt='' height={300} width={300} class='gallery-img'/>
                </Link>
                </div>
                <h5 class='gallery-head d-flex justify-content-center '>Industrial Facility</h5>
              </div>
              <div class='col-12 col-sm-12 col-md-6 col-lg-4'>
                <div class='d-flex justify-content-center'>
                <Link>
                <img src='./Images/sprink.png' alt='' height={300} width={300} class='gallery-img'/>
                </Link>
                </div>
                <h5 class='gallery-head d-flex justify-content-center '>Sprinkler pipe Installation</h5>
              </div>
            </div>
            <div class='row mt-5'>
              <div class='col-12 col-sm-12 col-md-6 col-lg-4'>
                <div class='d-flex justify-content-center'>
                <Link>
                <img src='./Images/control.png' alt='' height={300} width={300} class='gallery-img'/>
                </Link>
                </div>
                <h5 class='gallery-head d-flex justify-content-center '>Annual Maintenance Works</h5>
              </div>
              <div class='col-12 col-sm-12 col-md-6 col-lg-4'>
                <div class='d-flex justify-content-center'>
                <Link>
                <img src='./Images/industry.png' alt='' height={300} width={300} class='gallery-img'/>
                </Link>
                </div>
                <h5 class='gallery-head d-flex justify-content-center '>Industrial Facility</h5>
              </div>
              <div class='col-12 col-sm-12 col-md-6 col-lg-4'>
                <div class='d-flex justify-content-center'>
                <Link>
                <img src='./Images/sprink.png' alt='' height={300} width={300} class='gallery-img'/>
                </Link>
                </div>
                <h5 class='gallery-head d-flex justify-content-center '>Sprinkler pipe Installation</h5>
              </div>
            </div>
            <div class='row mt-5'>
              <div class='col-12 col-sm-12 col-md-6 col-lg-4'>
                <div class='d-flex justify-content-center'>
                <Link>
                <img src='./Images/control.png' alt='' height={300} width={300} class='gallery-img'/>
                </Link>
                </div>
                <h5 class='gallery-head d-flex justify-content-center '>Control panel Setup</h5>
              </div>
              <div class='col-12 col-sm-12 col-md-6 col-lg-4'>
                <div class='d-flex justify-content-center'>
                <Link>
                <img src='./Images/industry.png' alt='' height={300} width={300} class='gallery-img'/>
                </Link>
                </div>
                <h5 class='gallery-head d-flex justify-content-center '>Industrial Facility</h5>
              </div>
              <div class='col-12 col-sm-12 col-md-6 col-lg-4'>
                <div class='d-flex justify-content-center'>
                <Link>
                <img src='./Images/sprink.png' alt='' height={300} width={300} class='gallery-img'/>
                </Link>
                </div>
                <h5 class='gallery-head d-flex justify-content-center '>Sprinkler pipe Installation</h5>
              </div>
            </div>
            <div class='mt-5 '>
              <h2 class='gallery-t'>Why Our Work Stand Out</h2>
            </div>
            <div class='row mt-5'>
                            <div class='col-12 col-sm-12 col-md-12 col-lg-3 hyd-ro p-2'>
                                <FaCheckCircle class='gall-icon' />                              
                                <h4>Certified Installation</h4>
                               
                            </div>
                            <div class='col-12 col-sm-12 col-md-12 col-lg-3 hyd-ro p-2'>
                                <GrUserExpert class='gall-icon'  />
                                <h4>Expert Technicians</h4>
                                
                            </div>
                            <div class='col-12 col-sm-12 col-md-12 col-lg-3 hyd-ro p-2'>
                                <FaClockRotateLeft class='gall-icon'  />
                                <h4>On-time delivery</h4>
                                
                            </div>
                            <div class='col-12 col-sm-12 col-md-12 col-lg-3 hyd-ro p-2'>
                                <FaCheckCircle class='gall-icon'  /> 
                                <h4>Safety Compliance</h4>
                            </div>
            </div>
            <div class='row mt-4'>
              <h3 class='gall-l'>Need Reliable Fire Safety Solutions?</h3>
              <p class='gall-l1'>We Deliver Safety You Can Trust.</p>
              <button class="button">Contact Us</button>
            </div>
        </div> */}
        <div class='container'>
          <div class='row mt-4'>
            <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
              <img src='./Images/image8.png' height={250} width={250} alt='' class='image-gall' />
            </div>
            <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
              <img src='./Images/image9.png' height={250} width={250} alt='' class='image-gall' />
            </div>
            <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
              <img src='./Images/image10.png' height={250} width={250} alt='' class='image-gall' />
            </div>
            <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
              <img src='./Images/image11.png' height={250} width={250} alt='' class='image-gall' />
            </div>
          </div>
          <div class='row mt-3'>
            <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
              <img src='./Images/image.png' height={250} width={250} alt='' class='image-gall' />
            </div>
            <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
              <img src='./Images/image1.png' height={250} width={250} alt='' class='image-gall' />
            </div>
            <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
              <img src='./Images/image2.png' height={250} width={250} alt='' class='image-gall' />
            </div>
            <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
              <img src='./Images/image3.png' height={250} width={250} alt='' class='image-gall' />
            </div>
          </div>
          <div class='row mt-3'>
            <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
              <img src='./Images/image4.png' height={250} width={250} alt='' class='image-gall' />
            </div>
            <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
              <img src='./Images/image5.png' height={250} width={250} alt='' class='image-gall' />
            </div>
            <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
              <img src='./Images/image6.png' height={250} width={250} alt='' class='image-gall' />
            </div>
            <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
              <img src='./Images/image7.png' height={250} width={250} alt='' class='image-gall' />
            </div>
          </div>
          <div class='row mt-3'>
            <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
              <img src='./Images/image12.png' height={250} width={250} alt='' class='image-gall' />
            </div>
            <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
              <img src='./Images/image13.png' height={250} width={250} alt='' class='image-gall' />
            </div>
            <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
              <img src='./Images/image14.png' height={250} width={250} alt='' class='image-gall' />
            </div>
            <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
              <img src='./Images/image15.png' height={250} width={250} alt='' class='image-gall' />
            </div>
          </div>
          <div class='mt-5 '>
            <h2 class='gallery-t'>Why Our Work Stand Out</h2>
          </div>
          <div class='row mt-5'>
             <div class='col-12 col-sm-12 col-md-12 col-lg-3 hyd-ro p-2'>
             <FaCheckCircle class='gall-icon' />                              
             <h4>Certified Installation</h4>                           
             </div>
             <div class='col-12 col-sm-12 col-md-12 col-lg-3 hyd-ro p-2'>
             <GrUserExpert class='gall-icon'  />
             <h4>Expert Technicians</h4>                    
             </div>
             <div class='col-12 col-sm-12 col-md-12 col-lg-3 hyd-ro p-2'>
             <FaClockRotateLeft class='gall-icon'  />
             <h4>On-time delivery</h4>                           
             </div>
             <div class='col-12 col-sm-12 col-md-12 col-lg-3 hyd-ro p-2'>
             <FaCheckCircle class='gall-icon'  /> 
             <h4>Safety Compliance</h4>
             </div>
          </div>
          <div class='row mt-4'>
              <h3 class='gall-l'>Need Reliable Fire Safety Solutions?</h3>
              <p class='gall-l1'>📞We Deliver Safety You Can Trust.</p>
              <button class="button">Contact Us</button>
          </div>        
        </div>
    </div>
  )
}

export default Gallery